import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import auth from 'helpers/auth';
import PageContainer from '../../layout/PageContainer';
import CreditPolicyDetailBasicInfo from './CreditPolicyDetailBasicInfo';
import { API, BASE_URL, ROLES_ASEGURADO, ROLES_CORREDOR } from '../../../CONST';
import CreditPolicyDetailVigencias from './CreditPolicyDetailVigencias';
import CreditPolicyDetailContext from './CreditPolicyDetailContext';
import LoadingSpinner from '../../shared/LoadingSpinner';
import { userHasRole } from 'helpers/helpers';

const CreditPolicyDetail = ({
  match: { params: { id } },
  location: { state },
}) => {
  const [ policy, setPolicy ] = useState(null);
  const [ currentEndoso, setCurrentEndoso] = useState(null);

  const user = useSelector((state) => state.login.user);

  // Es asegurado únicamente, no es corredor
  const isAsegurado = userHasRole(user, ROLES_ASEGURADO) && !userHasRole(user, ROLES_CORREDOR);
  const initialVigencia = state?.vigencia;
  const breadcrumbs = React.useMemo(() => {
    if (isAsegurado) {
      return [
        { id: 0, name: 'SEGURO DE CR\u00C9DITO', url: '/' },
        { id: 1, name: 'MI P\u00D3LIZA', url: '/asegurado/polizas-credito' },
        { id: 2, name: 'DETALLE PÓLIZA' },
      ];
    }

    return [
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        {id: 1, name: 'ASEGURADO', url: '/asegurado/polizas-credito' },
        {id: 2, name: 'PÓLIZAS CRÉDITO', url: '/asegurado/polizas-credito' },
        {id: 3, name: 'DETALLE PÓLIZA'},
    ];
  }, [isAsegurado]);

  useEffect(() => {
    const url = `${BASE_URL}${API.fullCreditos}/${id}`;
    auth.fetch(url).then(response => {
      setPolicy(response);
    });
  }, [id]);

  return (
    <PageContainer
      breadcrumbs={breadcrumbs}
      returnTo={policy && state && state.returnTo ? state.returnTo : ''}
    >
      <LoadingSpinner isLoading={policy === null} overlayHeight='25rem' />

      {policy !== null && (
        <CreditPolicyDetailContext.Provider value={{currentEndoso, setCurrentEndoso}}>
          <CreditPolicyDetailVigencias policy={policy} initialVigencia={initialVigencia}/>
          <CreditPolicyDetailBasicInfo policy={policy} />
        </CreditPolicyDetailContext.Provider>
      )}
    </PageContainer>
  );
};

CreditPolicyDetail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      returnTo: PropTypes.string,
    }),
  }).isRequired,
};

export default CreditPolicyDetail;
